<template lang="pug">
  .years
    h2 {{ i18n('years') }}
    .year-list
      router-link.year(
        tag="div"
        v-for="year, number in yearList" :key="number"
        :to="{ name: 'year', params: { id: year.year } }"
        :class="year.events.length ? `element-${year.events[0].number ? year.events[0].number.value : 'null'} small` : 'empty'"
        )
        h3 {{ year.year.toString().slice(2, 4) }}
        span {{ year.events.map(({ symbol }) => symbol).join(', ') }}
    router-view
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'years',
  created() {
    this.listNumbers();
    this.listEvents();
  },
  computed: {
    ...mapGetters('locale', ['i18n']),
    ...mapState('events', ['events']),
    ...mapState('weekdays', ['keys', 'numbers']),
    yearList() {
      return Object.keys(this.keys.year)
        .map(yearS => {
          const year = parseInt(yearS, 10);
          return {
            year,
            events: this.events
              .filter(d => d.year === year)
              .map(event => {
                const number = this.numberByKey()(event.key);
                if (!number) {
                  // eslint-disable-next-line no-console
                  console.log('Missing number', event.key);
                  return event;
                }
                // event.color = this.colors[number.value];
                event.number = number;
                event.symbol = number.data.symbol;
                return event;
              })
          };
        })
    }
  },
  methods: {
    ...mapActions('events', ['listEvents']),
    ...mapActions('weekdays', ['listNumbers']),
    ...mapGetters('weekdays', ['numberByKey'])
  }
}
</script>

<style lang="stylus" scoped>

  .years
    margin 1rem
    position relative

  .year-list
    display flex
    flex-direction row
    flex-wrap wrap
    width 80vw
    height 320vw
    max-width 80vh
    margin 0 auto
  .year
    flex 0 0 19%
    height 4.5%
    box-sizing border-box
    padding .5rem
    margin .5%
    overflow hidden
    text-overflow ellipsis
    box-shadow 3px 3px 3px rgba(0, 0, 0, .1)
    font-size .75rem
    transform scale(1)

    h3
      margin 0 0 .125rem

    &.empty
      color #999
      background var(--block-background)
      @media (prefers-color-scheme: dark)
        color white
        background var(--block-background-dark)

    &.router-link-active
      background var(--background-color)
      opacity 1
      border 1px solid transparent
      @media (prefers-color-scheme: dark)
        background #222
        text-shadow #000 -.5px -1px 0
        border-color var(--text-color-dark)
      color inherit !important
      box-shadow 0px 0px 8px rgba(0, 0, 0, .5)
      // z-index 999
      transform scale(1.2)

  @media screen and (min-width: 640px)
    .year-list
      width 35rem
      height 35rem
      max-height 80vh
      .year
        flex 0 0 9%
        height 9%

</style>
